import { render, staticRenderFns } from "./proposal.vue?vue&type=template&id=629819cb&scoped=true&"
import script from "./proposal.vue?vue&type=script&lang=js&"
export * from "./proposal.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/proposal/proposal.less?vue&type=style&index=0&id=629819cb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629819cb",
  null
  
)

component.options.__file = "proposal.vue"
export default component.exports